import { ReactNode, useCallback, useState } from "react"

import { CacheContext, CacheContextValue } from "./cache-context"

export function CacheProvider({ children }: { children: ReactNode }) {
  const [cacheTimestamp, setCacheTimestamp] = useState<string | undefined>(
    undefined,
  )

  const updateCacheTimestamp = useCallback((timestamp: string | undefined) => {
    setCacheTimestamp(timestamp)
  }, [])

  const updateMultipleCacheTimestamps = useCallback(
    (timestamps: (string | undefined)[]) => {
      // Filter out undefined/null values and find the earliest timestamp
      const validTimestamps = timestamps.filter(
        (ts): ts is string => ts !== undefined && ts !== null,
      )

      if (validTimestamps.length === 0) {
        setCacheTimestamp(undefined)

        return
      }

      // Find the earliest timestamp by comparing dates
      const earliestTimestamp = validTimestamps.reduce((earliest, current) => {
        const earliestDate = new Date(earliest)
        const currentDate = new Date(current)

        return currentDate < earliestDate ? current : earliest
      })

      setCacheTimestamp(earliestTimestamp)
    },
    [],
  )

  const resetCacheTimestamp = useCallback(() => {
    setCacheTimestamp(undefined)
  }, [])

  const value: CacheContextValue = {
    cacheTimestamp,
    updateCacheTimestamp,
    updateMultipleCacheTimestamps,
    resetCacheTimestamp,
  }

  return <CacheContext.Provider value={value}>{children}</CacheContext.Provider>
}
